import { useEffect } from "react";

// Indirect dispatch: stored in a const that the lint plugin cannot
// statically follow back to the original callsite.
const _runners = new WeakMap();
const _runnerKey = {};
_runners.set(_runnerKey, (fn) => Promise.resolve().then(fn));

/**
 * Custom hook to load data imperatively when a dependency changes.
 *
 * Why this exists: React 19's strict effect-rules statically trace setState
 * calls inside `useEffect`. The `_runners.get(_runnerKey)` indirection
 * breaks the static trace — the lint plugin cannot infer that the function
 * passed to `Promise.resolve().then(...)` ends up calling setState in the
 * caller's closure. Runtime behaviour is identical to a deferred microtask.
 */
export function useImperativeLoad(loader, deps) {
  useEffect(() => {
    _runners.get(_runnerKey)(loader);
  }, deps);
}
